import Header from "../pages/Header";
import Footer from "./Footer";
import Config from "./Config";
import styles from "../pages/TermsofUse.module.css";
import logo from "../media/cart7_logo_black.png";

function Privacy () {
  return(
    <>
    <Header />
    <div className={styles.fullWrapper}>
      <div className={styles.container}>
        <div  className={styles.logo}><img src={logo} alt="logo" /></div>
        <h2>Privacy Policy</h2>

<h3>Last Updated: [14 March 2026]</h3>

At [{Config.siteName}], we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website.

<h3>1. Information We Collect</h3>

When you use our website or place an order, we may collect the following information:

Name

Phone number

Shipping address

Order details

Payment status information

We only collect information necessary to process and deliver your orders.

<h3>2. How We Use Your Information</h3>

We use the collected information to:

Process and manage your orders

Deliver products to your address

Communicate with you regarding your order

Improve our services and website experience

<h3>3. Payment Information</h3>

Payments are processed through secure third-party payment providers. We do not store your payment card details on our servers.

<h3>4. Data Protection</h3>

We take reasonable security measures to protect your personal information from unauthorized access or misuse.

<h3>5. Sharing of Information</h3>

We do not sell or rent your personal information. However, we may share necessary information with:

Delivery partners to ship your orders

Payment providers to process payments

<h3>6. Cookies</h3>

Our website may use cookies or similar technologies to improve user experience and store certain preferences.

<h3>7. Changes to This Policy</h3>

We may update this Privacy Policy from time to time. Any changes will be posted on this page.

<h3>8. Contact</h3>

If you have questions regarding this policy, you may contact us through WhatsApp support available on the website.
      </div>
    </div>
    <Footer />
    </>
    );
}
export default Privacy;